import { type UseQueryResult, useQuery } from 'react-query';
import {
  GrantService,
  StatusDropdownAppServicesService,
  Wealthlane_AwardService_Dtos_Common_PoolDropdownForAwardDto,
} from '@wealthlane/api-services/wealthlane-award-service';

const useGetPlanWithPoolDropdown = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
      poolName: string;
      poolId: string;
    }>
  | undefined,
  unknown
> => {
  const planWithPoolDropdown = useQuery(
    ['getPlanWithPoolDropdown'],
    async () => {
      return await handleRequest(GrantService.getApiAwardApiAppGrantPlansWithPoolForDropdown());
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
            poolName: item.poolName ?? '',
            poolId: item.poolId ?? '',
          };
        });
      },
    }
  );

  return planWithPoolDropdown;
};

export default useGetPlanWithPoolDropdown;
